/* PlantCeuticals homepage sections: rail arrows, mouse drag, variant prices, collection previews. */
(function () {
  function initRails(root) {
    root.querySelectorAll('[data-pc-rail]').forEach(function (rail) {
      if (rail.dataset.pcReady) return;
      rail.dataset.pcReady = '1';
      var section = rail.closest('.shopify-section') || document;
      section.querySelectorAll('[data-pc-rail-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          rail.scrollBy({ left: Number(btn.dataset.pcRailDir) * rail.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
      if (!rail.classList.contains('pc-rail--bar')) return;
      var x0 = 0, s0 = 0, down = false, moved = false;
      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.target.closest('select, button, input')) return;
        down = true; moved = false; x0 = e.clientX; s0 = rail.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - x0;
        if (!moved && Math.abs(dx) > 5) { moved = true; rail.classList.add('is-dragging'); }
        if (moved) rail.scrollLeft = s0 - dx;
      });
      window.addEventListener('pointerup', function () { down = false; rail.classList.remove('is-dragging'); });
      rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  function initCollectionRows(root) {
    root.querySelectorAll('[data-pc-crows]').forEach(function (list) {
      if (list.dataset.pcReady) return;
      list.dataset.pcReady = '1';
      var section = list.closest('.shopify-section') || document;
      var images = section.querySelectorAll('[data-pc-cprev] img');
      list.querySelectorAll('.pc-crow').forEach(function (row, i) {
        function show() {
          list.querySelectorAll('.pc-crow').forEach(function (r) { r.classList.toggle('is-active', r === row); });
          images.forEach(function (img, j) { img.classList.toggle('is-active', j === i); });
        }
        row.addEventListener('mouseenter', show);
        row.addEventListener('focus', show);
      });
    });
  }

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-pc-variant]');
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    var card = select.closest('[data-pc-card]');
    if (!card || !opt) return;
    var price = card.querySelector('[data-pc-price]');
    var compare = card.querySelector('[data-pc-compare]');
    var save = card.querySelector('[data-pc-save]');
    if (price) price.textContent = opt.dataset.price;
    if (compare) { compare.textContent = opt.dataset.compare || ''; compare.hidden = !opt.dataset.compare; }
    if (save) { save.textContent = opt.dataset.save || ''; save.hidden = !opt.dataset.save; }
    var submit = card.querySelector('[type="submit"]');
    if (submit) {
      var soldOut = opt.dataset.available === 'false';
      submit.disabled = soldOut;
      var label = submit.querySelector('span');
      if (label) label.textContent = soldOut ? submit.dataset.soldOut : submit.dataset.label;
    }
  });

  function init(root) { initRails(root); initCollectionRows(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
